module.exports = __webpack_public_path__ + "static/media/Usinag.d852c2f3.png";